<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-4 md:flex-row">
      <jade-box
        class="w-full"
        hasPadding
      >
        <jade-text
          color="medium"
          variant="text-small"
          weight="medium"
          >{{ $t('created-charges-tpv') }}</jade-text
        >
        <jade-text
          class="!mt-1"
          color="high"
          variant="display-small"
          >{{ computedTpvValue }}</jade-text
        >
      </jade-box>
      <jade-box
        class="w-full"
        hasPadding
      >
        <jade-text
          color="medium"
          variant="text-small"
          weight="medium"
          >{{ $t('total-authorized-volume') }}</jade-text
        >
        <jade-text
          class="!mt-1"
          color="high"
          variant="display-small"
          >{{ computedAuthorizedTpvValue }}</jade-text
        >
      </jade-box>
      <jade-box
        class="w-full"
        hasPadding
      >
        <jade-text
          color="medium"
          variant="text-small"
          weight="medium"
          >{{ $t('charges-amount') }}</jade-text
        >
        <jade-text
          class="!mt-1"
          color="high"
          variant="display-small"
          >{{ computedSalesLabel }}</jade-text
        >
      </jade-box>
      <jade-box
        class="w-full"
        hasPadding
      >
        <div class="flex gap-1">
          <jade-text
            color="medium"
            variant="text-small"
            weight="medium"
            >{{ $t('ticket') }}
          </jade-text>
          <jade-tooltip
            :text="$t('tippy-ticket')"
            placement="top-start"
          >
            <jade-icon
              use="circle-info"
              size="small"
            />
          </jade-tooltip>
        </div>
        <jade-text
          class="!mt-1"
          color="high"
          variant="display-small"
          >{{ computedAverageTicket }}</jade-text
        >
      </jade-box>
    </div>
    <jade-box
      :title="$t('charges.chat')"
      hasPadding
    >
      <template #action>
        <jade-dropdown
          :open="dropdownOpen"
          alignment="end"
          @closePopover="dropdownOpen = false"
          @toggleOpen="toggleOpen"
        >
          <template #trigger>
            <jade-action-button
              icon="chart-bar"
              dropdownIndicator
              active
              >{{ activeChart.label }}</jade-action-button
            >
          </template>
          <template>
            <jade-list-item
              v-for="option in chargeChartOptions"
              :key="option.value"
              :variant="
                activeChart.value === option.value ? 'active' : 'primary'
              "
              :label="option.label"
              @onClick="toogleTypeChart(option.value)"
              as="button"
            />
          </template>
        </jade-dropdown>
      </template>
      <dash-card-content-fallback :hasData="hasData">
        <chart-line-charges
          :type="typeChart"
          :data="data"
        />
      </dash-card-content-fallback>
    </jade-box>
  </div>
</template>

<script>
import Amplitude from '@/amplitude-events/resume.amplitude'
import MathManager from '@/utils/math-manager.utils'

import DashCardContentFallback from '../components/DashCardContentFallback/index.vue'

import CHARGES_ENUM from './charge.enum'
import ChartLineCharges from './ChartLineCharges.vue'

import {
  JadeActionButton,
  JadeBox,
  JadeText,
  JadeListItem,
  JadeTooltip,
  JadeIcon,
  JadeDropdown
} from '@jade'

export default {
  name: 'Charges',

  components: {
    DashCardContentFallback,
    ChartLineCharges,
    JadeActionButton,
    JadeBox,
    JadeListItem,
    JadeText,
    JadeTooltip,
    JadeIcon,
    JadeDropdown
  },

  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      typeChart: CHARGES_ENUM.TPV,
      typeChartEnum: CHARGES_ENUM,
      dropdownOpen: false,
      chargeChartOptions: [
        {
          label: this.$t('total-traded-volume'),
          value: CHARGES_ENUM.TPV
        },
        {
          label: this.$t('charges-amount'),
          value: CHARGES_ENUM.SALES
        },
        {
          label: this.$t('ticket'),
          value: CHARGES_ENUM.TICKET
        }
      ]
    }
  },
  computed: {
    computedTpvValue () {
      return MathManager.formatCurrency(this.data.tpvLabel)
    },
    computedAuthorizedTpvValue () {
      return MathManager.formatCurrency(this.data.authorizedTpvLabel)
    },
    computedAverageTicket () {
      return MathManager.formatCurrency(this.data.ticketLabel)
    },
    computedSalesLabel () {
      return MathManager.formatNumberDecimal(this.data.salesLabel)
    },
    hasData () {
      return this.data.tpvLabel > 0
    },
    activeChart () {
      return this.chargeChartOptions.find(
        option => option.value === this.typeChart
      )
    }
  },
  methods: {
    toogleTypeChart (newType) {
      this.typeChart = newType
      Amplitude.events.filters.chargeTypeChanged({ type: newType })
    },
    toggleOpen (value) {
      this.dropdownOpen = !!value
    }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "charges.chat": "Gráfico de cobranças",
      "charges-title": "Cobranças",
      "created-charges-tpv": "Cobranças criadas (TPV)",
      "total-traded-volume": "Volume total transacionado (TPV)",
      "total-authorized-volume": "Cobranças autorizadas (TPV)",
      "tippy-ticket": "Valor médio das compras feitas no seu site/app, calculado com base nas transações de status \"Paga\".",
      "charges-amount": "Número de cobranças",
      "ticket": "Ticket médio"
    },
    "en-US": {
      "charges.chat": "Charges chart",
      "charges-title": "Charges",
      "created-charges-tpv": "Created charges (TPV)",
      "total-traded-volume": "Total traded volume (TPV)",
      "total-authorized-volume": "Authorized charges (TPV)",
      "tippy-ticket": "Average value of purchases made on your website/app, calculated based on transactions with the status \"Paid\".",
      "charges-amount": "Number of charges",
      "ticket": "Average ticket"
    }
  }
</i18n>
